import { Fade } from "@mui/material";
import type { FunctionComponent } from "react";
import { useState } from "react";
import { SwitchTransition } from "react-transition-group";
import { NewsletterContextProvider, NewsletterVariant } from "scmp-sdk";

import { newsletter } from "shared/data";

import { useNewsletterWidget } from "scmp-app/components/newsletter/newsletter-widget-container/hooks";
import {
  WaveBottomBackground,
  WaveUpperBackground,
} from "scmp-app/components/posties/wave-background";

import ImgPiggledy from "./img-piggledy.png";
import {
  Container,
  ContentContainer,
  Description,
  Header,
  ImageContainer,
  StyledImagePiggledy,
  StyledNewsletterWidget,
  Wrapper,
} from "./styles";

type Props = {
  className?: string;
};

export const SignUpNewsletter: FunctionComponent<Props> = ({ className }) => {
  const { dataMatrix } = useNewsletterWidget({
    contentType: "posties",
    eventCategory: "Newsletter (Posties - Inline)",
    section: "",
  });
  const [isSuccess, setIsSuccess] = useState(false);

  const handleRenderTextComponent = () => {
    if (isSuccess)
      return (
        <>
          <Header>Thanks for signing up to our newsletter!</Header>
          <Description>Please check your email to confirm your subscription</Description>
        </>
      );
    return (
      <>
        <Header>Sign up to our FREE monthly newsletter</Header>
        <Description>
          Get the latest education news, learning tips, and trending topics straight to your inbox.
        </Description>
      </>
    );
  };

  return (
    <Container className={className} id="newsletter">
      <WaveUpperBackground $fillColor="#0f75bf" />
      <Wrapper>
        <SwitchTransition mode="out-in">
          <Fade appear={false} key={String(isSuccess)} timeout={500}>
            <ContentContainer>
              {handleRenderTextComponent()}
              <NewsletterContextProvider
                value={{
                  dataMatrix,
                  newsletterItems: [
                    {
                      entityId: newsletter.posties.entityId,
                      name: newsletter.posties.entityLabel,
                    },
                  ],
                  variant: NewsletterVariant.Posties,
                }}
              >
                <StyledNewsletterWidget
                  $isHidden={isSuccess}
                  onSuccess={() => {
                    setIsSuccess(true);
                  }}
                />
              </NewsletterContextProvider>
            </ContentContainer>
          </Fade>
        </SwitchTransition>
        <ImageContainer>
          <StyledImagePiggledy
            $aspectRatio="auto"
            $objectFit="contain"
            disableLinkingData
            src={ImgPiggledy.src}
          />
        </ImageContainer>
      </Wrapper>
      <WaveBottomBackground $fillColor="#0f75bf" />
    </Container>
  );
};

SignUpNewsletter.displayName = "SignUpNewsletter";
